class HtwVideo extends HTMLElement {
  connectedCallback() {
    if (this.dataset.ready) return;

    this.videoId = this.dataset.embed;
    if (!this.videoId) return;

    this.dataset.ready = 'true';
    this.button = this.querySelector('.htw-v2__video-play');

    this.addPoster();
    this.button?.addEventListener('click', () => this.play());
  }

  addPoster() {
    const poster = document.createElement('img');
    poster.className = 'htw-v2__video-poster reset-img';
    poster.loading = 'lazy';
    poster.width = 1280;
    poster.height = 720;
    poster.alt = '';

    poster.addEventListener('error', () => {
      if (poster.dataset.fallback) return;
      poster.dataset.fallback = 'true';
      poster.src = `https://i.ytimg.com/vi/${this.videoId}/hqdefault.jpg`;
    });

    poster.src = `https://i.ytimg.com/vi_webp/${this.videoId}/maxresdefault.webp`;
    this.prepend(poster);
  }

  play() {
    if (this.hasAttribute('loaded')) return;
    this.setAttribute('loaded', '');

    const iframe = document.createElement('iframe');
    iframe.className = 'htw-v2__video-frame';
    iframe.title = this.dataset.title || 'How to wear';
    iframe.allow = 'autoplay; encrypted-media; picture-in-picture; fullscreen';
    iframe.allowFullscreen = true;
    iframe.src = `https://www.youtube.com/embed/${this.videoId}?rel=0&showinfo=0&vq=720&autoplay=1`;

    this.appendChild(iframe);
    iframe.focus();
  }
}

customElements.define('htw-video', HtwVideo);
